/**
 * The function toLocaleDateString accepts both locale or locale-region style.
But in the specific case of arabic, it seems the locale ar doesn’t translate the numbers.
The essence of this mapping function is to map any edge cases like 'ar' to the required format
so toLocaleDateString can work as intended
* the languageCode only accept xx-xx format ex. en-UK
 */

const LANGUAGE_CODE_MAP: Record<string, string> = { ar: 'ar-EG' };

const mapLanguageCodeForStringFormat = (languageCode: string) => {
  const parseLocale = languageCode.replace('_', '-');
  return LANGUAGE_CODE_MAP[parseLocale] ?? parseLocale;
};

export default mapLanguageCodeForStringFormat;
